import { Box, BoxProps, Flex, styled, TextV2 } from '@withjoy/joykit';
import React from 'react';

// Constants for styling
const SEGMENT_CONTAINER_HEIGHT = 52; // Height of the container
const SEGMENT_PADDING = 6; // Padding inside the container
const PILL_HEIGHT = 40; // Height of the pill
const PILL_BORDER_RADIUS = 200; // Border radius for pills
const PILL_MARGIN = 6; // Margin between pills

const SegmentPill = styled(Flex)<{ selected?: boolean }>`
  flex: 1;
  height: ${PILL_HEIGHT}px;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  user-select: none;

  z-index: 3;

  border-radius: ${PILL_BORDER_RADIUS}px;
  margin: 0 ${PILL_MARGIN}px; /* Add spacing between pills */
`;

const PillSlider = styled(Box)<{ index?: number; segmentCount: number }>`
  position: absolute;
  top: ${SEGMENT_PADDING}px;
  left: ${({ index = 0, segmentCount }) => `calc(${(index / segmentCount) * 100}% + ${PILL_MARGIN}px)`};
  width: calc(${props => 100 / props.segmentCount}% - ${PILL_MARGIN * 2}px);
  height: ${PILL_HEIGHT}px;

  background: var(--System-White, #fff);
  box-shadow: 0 1px 3px -1px rgba(51, 51, 51, 0.1);

  border-radius: ${PILL_BORDER_RADIUS}px;
  z-index: 2;

  transition: left 0.2s ease-in-out;
`;

const SegmentContainer = styled(Flex)`
  position: relative;
  display: flex;
  height: ${SEGMENT_CONTAINER_HEIGHT}px;
  padding: ${SEGMENT_PADDING}px; /* Padding inside the container */
  align-items: center;
  z-index: 1;

  border-radius: ${PILL_BORDER_RADIUS}px;
  background: var(--mono-2-bg, #f7f7f7);
`;

type SegmentConfig = {
  label: string;
};

type SegmentsProps = {
  segments: SegmentConfig[];
  onSelect?: (index: number, content: SegmentConfig) => void;
  selectedIndex?: number;
} & Omit<BoxProps, 'onSelect'>;

export const SegmentedControl = (props: SegmentsProps) => {
  const { segments, selectedIndex = 0, onSelect, ...containerStyleProps } = props;

  return (
    <>
      <SegmentContainer {...containerStyleProps}>
        <PillSlider
          index={selectedIndex}
          segmentCount={segments.length}
        />
        {segments.map((segment, index) => (
          <SegmentPill
            key={index}
            selected={selectedIndex === index}
            onClick={() => onSelect?.(index, segment)}
          >
            <TextV2 typographyVariant="body3">{segment.label}</TextV2>
          </SegmentPill>
        ))}
      </SegmentContainer>
    </>
  );
};
